export const menuList = [
  {
    title: "Use Cases",
    href: "/use-cases/",
    key: "use-cases",
  },

  {
    title: "Pricing",
    href: "/pricing/",
    key: "pricing",
  },
  {
    title: "Agent Framework",
    href: "https://eko.fellou.ai/",
    key: "agent-framework",
  },
  // {
  //   title: "Github",
  //   key: "github",
  //   href: "github",
  // },

  {
    key: "blog",
    href: "https://fellou.ai/blog",
    title: "Blog",
  },

  {
    key: "join-us",
    title: "Join Us",
    href: "https://salt-sovereign-101.notion.site/Fellou-Join-Us-14936270eaab8095bfd2cfe72a682ead",
  },
];
